import { render, staticRenderFns } from "./home_stat.vue?vue&type=template&id=9f1bd1d8&scoped=true&"
import script from "./home_stat.vue?vue&type=script&lang=js&"
export * from "./home_stat.vue?vue&type=script&lang=js&"
import style0 from "./home_stat.vue?vue&type=style&index=0&id=9f1bd1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1bd1d8",
  null
  
)

export default component.exports